import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'highlightByStart',
})
export class HighlightByStartPipe implements PipeTransform {
  transform(value: string, byStart: number, inputLength: number): string {
    return (
      value.substring(0, byStart) +
      `<b>${value.substring(byStart, byStart + inputLength)}</b>` +
      value.substring(byStart + inputLength)
    );
  }
}
